var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuinline = function SvgMenuinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.858c0-.594.478-1.072 1.071-1.072H20.93c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07A1.069 1.069 0 0 1 2 4.858ZM2 12c0-.593.478-1.071 1.071-1.071H20.93c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.069 1.069 0 0 1 2 12Zm14 7.143c0 .594-.478 1.072-1.071 1.072H3.07A1.069 1.069 0 0 1 2 19.143c0-.594.478-1.071 1.071-1.071H14.93c.593 0 1.071.477 1.071 1.071Z",
    fill: "#000"
  })));
};
export default SvgMenuinline;